<div class="dialog-container" [ngClass]="{'selectiveDownload': source === 'selectiveDownload', 'map-test-case-confirmation': data?.title === 'Link Test Cases confirmation'}">
  <div mat-dialog-title id="modal-header">
    {{data.title}}
    <img class="close-btn" [matDialogClose]="!isAiAgent ? undefined : null" src="assets/images/closeIcon.svg" (click)="isAiAgent ? close('close') : null" alt="close-icon" />  
  </div>
  <div mat-dialog-content id="modal-content">
    @switch (data.contentType) {
      @case (dialogContentType.SIMPLE) {
        <div [innerHTML]="data.message"></div>
      }
      @case (dialogContentType.CHIPS) {
        <div>
          <mat-chip-listbox [selectable]="false" [class.l3-popup-chip-list]="data.chipStyle === 'l3Process'">
            @for (item of data.message; track item) {
              <mat-chip-option [class.l3-popup-chip]="data.chipStyle === 'l3Process'">
                <span class="l3-popup-chip-content" [class.l3-popup-chip-content]="data.chipStyle === 'l3Process'">
                  @if (item.highlighterText) {
                    <span class="highligher-text" [class.l3-popup-highlighter]="data.chipStyle === 'l3Process'">{{item.highlighterText}}</span>
                  }
                  <span class="display-text" [class.l3-popup-display]="data.chipStyle === 'l3Process'" [attr.title]="data.chipStyle === 'l3Process' ? ((item.highlighterText ? item.highlighterText + ' ' : '') + item.displayText) : null">{{item.displayText}}</span>
                </span>
                <button matChipRemove (click)="removeFromList(item, data.message)">
                  <img [src]="data.chipStyle === 'l3Process' ? 'assets/images/cross.svg' : 'assets/images/cross-white.svg'" />
                </button>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      }
      @default {
        <div>{{data.message}}</div>
        @if(hasInfoMessage) {
        <div class="info">
          <img class="info-icon" src="assets/images/info.svg" alt="info-icon" />
          <div class="info-text">{{data.info}}</div>
        </div>
        }
      }
    }
  </div>
  @if(hasWarningMessage) {
  <div class="warning">
    <img class="warning-icon" src="assets/images/warning.svg" alt="warning-icon" />
    <div class="warning-text">{{data.warning}}</div>
  </div>
  }


  <div id="modal-footer" [class]="from ? 'space-between' : 'flex-end'">
    @if (!data.buttons) {
      @if(from){
        <button class="btn-secondary-s m-r-24" mat-dialog-close>
          <img alt="back arrow" style="padding-right: 7px;" src="assets/images/back-arrow-outline.svg"/>
          {{data.secondaryButton ?? cancelButton}}
        </button>
        <button class="btn-primary-s" (click) = "confirm()" cdkFocusInitial>{{data.primaryButton ?? confirmButton}}</button>

      } @else {
      <button class="btn-secondary-s m-r-24" [mat-dialog-close]="!isAiAgent ? false : null"
        (click)="isAiAgent ? close('regenerate') : null">
        {{isAiAgent ? 'Regenerate Bot' : (data.secondaryButton ?? cancelButton)}}
      </button>
      <button class="btn-primary-s" [mat-dialog-close]="!isAiAgent ? true : null" (click)="isAiAgent ? close('same') : null"
        cdkFocusInitial>
        {{ isAiAgent ? 'Continue with same Bot' : (data.primaryButton ?? confirmButton)}}
      </button>
      }
    } @else {
      @for (action of data.buttons; track action) {
        <button class="btn-secondary-s m-r-24" [mat-dialog-close]="action.type === 'cancel' ? false : true">{{action.text}}</button>
      }
    }
  </div>
</div>